@if (error$ | async; as error) {
	<stages-dialog2 #dialog>
		<stages-dialog-header />
		<div class="content slide-container">
			<h1 translate="{{ error?.titleKey }}"></h1>
			<div class="panel">
				<p>{{ error?.message }}</p>
			</div>
			<div class="panel">
				<div class="switch-details">
					<h5 translate="details"></h5>
					<input id="details" type="checkbox" hidden="hidden" [(ngModel)]="details" (click)="toggleState()" />
					<label for="details" class="switch"></label>
				</div>
			</div>
			<div class="two-slot-slide-panels" [@swipe]="detailsState">
				<div class="slide-panel">
					<img [attr.alt]="'files.backgroundimage' | translate" class="birds" src="img/birds.svg" />
				</div>
				<div class="slide-panel">
					<ul class="list">
						@if (error?.jobDetails) {
							<li class="list-item">
								<div class="label">
									<div class="text">
										<h4 translate="files.error.job.started"></h4>
										<p
											translate="files.error.job.info"
											[translateParams]="{ date: error?.jobDetails?.date, user: error?.jobDetails?.user?.fullname }"
										></p>
									</div>
								</div>
							</li>
						}
						@for (detail of errorDetails$ | async; track detail) {
							<li class="list-item">
								<div class="label">
									<div class="text">
										<h4 [translate]="$any(detail).key"></h4>
										<p>{{ $any(detail).value }}</p>
									</div>
								</div>
							</li>
						}
					</ul>
				</div>
			</div>
		</div>
		<footer>
			<div class="buttons">
				<button class="sm" (click)="dialog.close()" translate="close"></button>
			</div>
		</footer>
	</stages-dialog2>
}
